import React, { ReactElement } from "react";
import { Table } from "antd";
import { AdsAndSmbsRecord } from "../../../redux/types/reportTypes";

export const columns = [
  {
    title: "Cluster",
    dataIndex: "cluster",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "PUB ID",
    dataIndex: "publisher",
  },
  {
    title: "Origami",
    dataIndex: "origami",
  },
  {
    title: "SMBS",
    dataIndex: "smbs",
  },
  {
    title: "ADS",
    dataIndex: "ads",
  },
  {
    title: "ADS PER SMB",
    dataIndex: "adsPerSmb",
  },
];

type AdsAndSmbsTableProps = {
  loading: boolean;
  records: Array<AdsAndSmbsRecord>;
};

const AdsAndSmbsTable = ({ loading, records }: AdsAndSmbsTableProps): ReactElement => (
  <Table
    dataSource={records}
    columns={columns}
    loading={loading}
    rowKey="publisher"
    pagination={false}
    scroll={{ y: 250 }}
  />
);

export default AdsAndSmbsTable;
